import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class PeopleTableTableCellRolesSelectIndexComponent extends DropdownActivator {
  @service store;

  @tracked roleFormIsVisible = false;

  selectedPerson = null;

  get person() {
    return this.args.person;
  }

  @action
  toggleRoleForm(person, val) {
    if (person) this.selectedPerson = person;
    else this.selectedPerson = null;
    if (val !== undefined) this.roleFormIsVisible = val;
    else this.roleFormIsVisible = !this.roleFormIsVisible;
  }

  get roleIds() {
    return (this.person.roles.content ?? []).map((role) => role.id);
  }

  @action
  async handleRoleClick(person, role_ids) {
    person.roles = role_ids
      .map((id) => this.store.peekRecord('role', id))
      .filter((item) => !!item);
    await person.save();
    person.reload();
  }

  @action
  async onRoleAdded(role) {
    const person = this.selectedPerson;
    const roles = (person.roles?.content ?? []).map((item) => item.id);
    roles.push(role.id);
    await this.handleRoleClick(person, roles);
  }

  willDestroy() {
    this.selectedPerson = null;
    this.roleFormIsVisible = false;
    super.willDestroy(...arguments);
  }
}
